import moment from 'moment';
import { dateFormats } from '../../constants';

export default (input, inputFormat = dateFormats.cardInput, outputFormat = dateFormats.cards) => {
  const date = moment(input, inputFormat);
  return date.isValid() ? date.format(outputFormat) : '';
};
